module.exports = __webpack_public_path__ + "static/media/cases_anuncios_02b.fcb68af0.jpg";